import {Component, EventEmitter, Input, Output} from '@angular/core';
import {FormsModule} from "@angular/forms";

export interface ActiveFeaturesForm {
  onlineAgenda: boolean;
  patientApp: boolean;
  ivgModule: boolean;
  kineModule: boolean;
  bubblelink: boolean;
}

@Component({
  selector: 'ms-form-active-features',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './form-active-features.component.html',
  styleUrl: './form-active-features.component.scss'
})
export class FormActiveFeaturesComponent {

  @Input() set initialForm(initialForm: ActiveFeaturesForm | null) {
    if (!initialForm) return;
    this.form = {...this.form, ...initialForm};
    this.onFieldChange();
  }
  @Output() formChange = new EventEmitter<ActiveFeaturesForm>();

  public form: ActiveFeaturesForm = {
    onlineAgenda: false,
    patientApp: false,
    ivgModule: false,
    kineModule: false,
    bubblelink: false,
  };

  public onFieldChange() {
    this.formChange.emit({...this.form});
  }
}
